
<template>    
       <div class='quantity-chooser'>
           <span @click="change(-1)" class='btn minus dim'>  <ico icon="minus-circle" /> </span>
           <input class="value" v-model="quantity">
           <span @click="change(1)" class='btn plus dim'>   <ico icon="plus-circle" /> </span>
       </div>
</template>

<script>
export default {

     data(){
        return {
            quantity:0,
        }
    },

    props:{
        value:{
            default:0
        },
        max:{
            default:10
        },
        min:{
            default:0
        }
    },

    watch:{
        value:function(){
            this.quantity = parseInt(this.value,10);
        },
        quantity:function(val){
            this.$emit('change',val)
            this.$emit('input',val)
        }
    },


    created:function(){
        this.quantity = parseInt(this.value,10);
    },

    methods:{
        change:function(amount){
            if(amount == -1){
                this.$emit('minusClick')
            }
            if(amount == 1){
                this.$emit('plusClicked')
            }
            this.quantity = this.calculate(parseInt(this.value) + amount)
        },
        
        calculate:function(val){
            if(val > this.max) val = this.max
            if(val < this.min) val = this.min
            return val;
        }
    }
}
</script>

<style lang="stylus">
    
    .quantity-chooser{
        display:inline-flex;
        align-items: center;
        padding:0;
        margin:0;
        // background red;

        input{
            border:none;
            background none;
            width 1.1em;
            text-align:center;
            font-size:2em;
            border-radius:8px;
            &:hover,&:focus{
                background rgba(white,0.2);
            }
        }

        .btn{
            margin:0;
            padding:0;
            text-align:center;
            border-radius:50%;
            padding:0.2em 0.2em;
            // background rgba(black,0.2)
            font-weight bold
            font-size:1.3em
        }
        .plus{
            // color:var(--primary,black);
            font-size:1.3em;
        }
    }

</style>
